export const GET_LAST_VISIT_PROCESSED_DATE = `query  getLastVisitProcessedDate{
    getLastVisitProcessedDate  
}`
